import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModeService } from './common/services/app.mode.service';
// import {} from '@types/googlemaps';
// import {} from 'facebook-js-sdk';

import { AppModule } from './components/app/app.module';

if (!AppModeService.isDevelopmentMode) {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule).catch(console.error);



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/main.ts